// JavaScript Document
// Version: 1.0.0

jQuery(document).ready(function($) {
	$('.binoculars .blocks-gallery-grid').slick({
		dots: false,
		accessibility: false,
		arrows: false,
		draggable: false,
		pauseOnFocus: false,
		pauseOnHover: false,
		swipe: false,
		touchMove: false,
		autoplay: true,
		autoplaySpeed: 4000,
		speed: 1500,
		infinite: true,
		fade: true,
		cssEase: 'linear',
		lazyLoad: 'ondemand'
	}).css('opacity', 1);


});



function calcHeight() {
	var mobileBar = (jQuery('body').hasClass('is-mobile') && !jQuery('body').hasClass('is-tablet')) ? 80 : 10;

	jQuery('.entry-content.full-height').css('height', 'calc(100vh - ' + (jQuery('#site-header').outerHeight() + mobileBar) + 'px)');
}
